import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["set"] = "searchBoxState/set";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    set: createAction(ActionTypes.set, (searchBoxState) => ({
        payload: { searchBoxState }
    }))
};
